<div class="date-range-filter space-y-3">
  <!-- Label and Clear Button -->
  <div class="flex items-center justify-between">
    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {{ label() }}
    </label>
    @if (showClearButton() && hasActiveFilter()) {
      <button
        type="button"
        (click)="clearFilter()"
        [disabled]="disabled()"
        class="text-xs text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 
               transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none 
               focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 rounded px-1"
        aria-label="Clear date filter">
        Clear
      </button>
    }
  </div>

  <!-- Date Presets -->
  @if (presets().length > 0) {
    <div class="flex items-center gap-2 flex-wrap">
      @for (preset of presets(); track preset.value) {
        <button
          type="button"
          (click)="onPresetClick(preset.value)"
          [disabled]="disabled()"
          [class]="isPresetSelected(preset.value)
            ? 'bg-blue-600 text-white dark:bg-blue-500 ring-2 ring-blue-400 dark:ring-blue-300 shadow-sm' 
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'"
          class="px-3 py-1.5 text-xs font-medium rounded-lg transition-all duration-200 
                 disabled:opacity-50 disabled:cursor-not-allowed
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
                 dark:focus:ring-offset-gray-800"
          [attr.aria-pressed]="isPresetSelected(preset.value)"
          [attr.aria-label]="'Apply ' + preset.label + ' date filter'">
          {{ preset.label }}
        </button>
      }
    </div>
  }

  <!-- Custom Date Range Inputs -->
  <div class="grid grid-cols-2 gap-3">
    <!-- Date From -->
    <div>
      <label 
        for="date-from-{{ label() }}" 
        class="block text-xs text-gray-600 dark:text-gray-400 mb-1">
        From
      </label>
      <input
        type="date"
        [id]="'date-from-' + label()"
        [value]="internalDateFrom()"
        (input)="onDateFromInput($any($event.target).value)"
        [max]="dateTo() || today"
        [disabled]="disabled()"
        class="block w-full px-3 py-2 text-sm border rounded-lg 
               bg-white dark:bg-gray-700 
               text-gray-900 dark:text-white
               border-gray-300 dark:border-gray-600
               placeholder-gray-400 dark:placeholder-gray-500
               focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 
               focus:border-transparent 
               disabled:opacity-50 disabled:cursor-not-allowed
               transition-all"
        [class.border-red-500]="!isValid() && showValidation()"
        [class.dark:border-red-400]="!isValid() && showValidation()"
        aria-label="Date from">
    </div>

    <!-- Date To -->
    <div>
      <label 
        for="date-to-{{ label() }}" 
        class="block text-xs text-gray-600 dark:text-gray-400 mb-1">
        To
      </label>
      <input
        type="date"
        [id]="'date-to-' + label()"
        [value]="internalDateTo()"
        (input)="onDateToInput($any($event.target).value)"
        [min]="dateFrom() || undefined"
        [max]="today"
        [disabled]="disabled()"
        class="block w-full px-3 py-2 text-sm border rounded-lg 
               bg-white dark:bg-gray-700 
               text-gray-900 dark:text-white
               border-gray-300 dark:border-gray-600
               placeholder-gray-400 dark:placeholder-gray-500
               focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 
               focus:border-transparent 
               disabled:opacity-50 disabled:cursor-not-allowed
               transition-all"
        [class.border-red-500]="!isValid() && showValidation()"
        [class.dark:border-red-400]="!isValid() && showValidation()"
        aria-label="Date to">
    </div>
  </div>

  <!-- Validation Error Message -->
  @if (!isValid() && showValidation()) {
    <p class="text-xs text-red-600 dark:text-red-400 animate-fadeIn" role="alert">
      {{ validationErrorMessage() }}
    </p>
  }
</div>
